export const URL = `${process.env.NODE_ENV === "production" ?
  "wss" :
  "ws"}://${process.env.VUE_APP_API_URL}/api/cable`;
